import React from 'react'
import styled from 'styled-components'
import { Body01 } from '~/components/common/typography'
import { translate } from '~/core/translate'

const Container = styled(Body01)`
 color: ${props => props.theme._neo.action05};
 cursor: pointer;
`

const Toggle = ({ isExpanded, onToggle }) =>
  <Container onClick={onToggle}>
    {isExpanded ? translate('hide_details') : translate('show_details')}
  </Container>

export default Toggle
